import React, { Component } from 'react';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import { _addNotification, _addNotificationError, formatDate,allowNumericWithdecimal } from '../../../server/util';
import {get, postWithHeaders, patch} from "../../../server/actions";
let lowBalanceUpdate = false;
class LowBalEmailEntry extends Component {

    constructor(props) {
        super(props);
      this.state={
        loading:false,
        lowBalData:{
            recId:0,
            runOn:{'Sun':false,'Mon':false,'Tue':false,'Wed':false,'Thu':false,'Fri':false,'Sat':false},
            paused:false,
            at:{hrs:'',am_pm:'AM'},
            custEmailIsBlank:false,
            bal:{min:0.00,max:0.00},
            exZeroBal:false,
            lowBalMsg:'As of <DATE>, the meal account for <NAME> has <REMAINING/DUE>. Please make a deposit right away to ensure that there is sufficient money for <NAME> to make purchases. <br/><br/> This is an auto mated low balance notification provided as ',
            lastRanOn:''
        }
      }  
      this.onSubmit=this.onSubmit.bind(this);
    }
    componentDidMount(){
        this._notificationSystem = this.refs.notificationSystem;
        get('/lowBalanceSchoolSettings/search/findByMealSchoolSchoolId?schoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let respData = data._embedded.lowBalanceSchoolSettings;
            if(respData.length > 0){
            let objData = {'Sun':false,'Mon':false,'Tue':false,'Wed':false,'Thu':false,'Fri':false,'Sat':false};
            Object.keys(objData).map(obj=>{
            respData[0].scheduledDayList.map((day) => {
                if(day === obj){
                    objData[obj]=true
                }
            });
            })           
            this.setState({
                lowBalData:{
                    recId:respData[0]._links.self.href.split('/').pop(),
                    runOn:objData,
                    paused:respData[0].isPaused,
                    at:{hrs:parseInt(respData[0].runTime) == 0 ? 12 : parseInt(respData[0].runTime) == 12 ? parseInt(respData[0].runTime) :parseInt(respData[0].runTime) < 12 ? parseInt(respData[0].runTime) < 10 ? '0'+(parseInt(respData[0].runTime)):parseInt(respData[0].runTime) :  parseInt(respData[0].runTime) - 12 < 10 ? '0'+(parseInt(respData[0].runTime) - 12) : parseInt(respData[0].runTime) - 12,am_pm:parseInt(respData[0].runTime) >= 12 ? 'PM' : 'AM'},
                    //at:{hrs:parseInt(respData[0].runTime) > 12 ? (12 - (24 % parseInt(respData[0].runTime))) < 10 ? '0'+(12 - (24 % parseInt(respData[0].runTime))) : (12 - (24 % parseInt(respData[0].runTime))) : respData[0].runTime,am_pm:respData[0].runTime < 12 ? 'AM' : 'PM'},
                    custEmailIsBlank:false,
                    bal:{min:respData[0].lowBalMinCriteria,max:respData[0].lowBalMaxCriteria},
                    exZeroBal:respData[0].isExcludeZeroBal,
                    lowBalMsg:respData[0].messageBody,
                    lastRanOn:respData[0].lastRanDate
                }
            })
        }
        })
            .catch(
                (error) => {
                    //_addNotificationError('Activation failed. Please try again later', this);
                    console.log('Low balance school setting', error)
                }
            )
    }
    
    hrs12Options=()=>{
        let options=[{text:'Select',value:''}];
        for (var i = 60; i <= 750; i += 60) {
           let hours = Math.floor(i / 60);
           
           // minutes = i % 60;
            //if (minutes < 10) {
           //     minutes = '0' + minutes; // adding leading zero to minutes portion
           // }
            //add the value to dropdownlist
            options.push({text:hours < 10 ? '0'+hours : hours,value:hours < 10 ? '0'+hours : hours});            
        }
        return options
    }
    onSubmit=()=>{
        let lowBalObj=this.state.lowBalData;
        let _selectedDays=[];
        Object.keys(lowBalObj.runOn).map(obj=>{
           if(lowBalObj.runOn[obj]===true){
            _selectedDays.push(obj);
           } 
        })

        if(_selectedDays.length<=0){
            _addNotificationError('Atleast one day in a week required.',this);
            return false;
        }
        // if((lowBalObj.at.hrs).trim()==''){
        //     _addNotificationError('Time is required.',this);
        //     return false;
        // }
        // if((lowBalObj.lowBalMsg).trim()==''){
        //     _addNotificationError('Low balance message is required.',this);
        //     return false;
        // }
        if(lowBalObj.at.am_pm === 'PM'){
            lowBalObj.at.hrs =parseInt(lowBalObj.at.hrs) < 12 ? parseInt(lowBalObj.at.hrs) + 12 : parseInt(lowBalObj.at.hrs);
        }
        if(lowBalObj.at.am_pm === 'AM'){
            lowBalObj.at.hrs =parseInt(lowBalObj.at.hrs) == 12 ? 0 : parseInt(lowBalObj.at.hrs);
        }
        let data = JSON.stringify({
            mealSchool:"/mealManage/mealSchools/"+sessionStorage.getItem('SchoolId'),
            runTime:lowBalObj.at.hrs+':00',
            lowBalMinCriteria:lowBalObj.bal.min,
            lowBalMaxCriteria:lowBalObj.bal.max,
            isExcludeZeroBal:lowBalObj.exZeroBal,
            messageBody:lowBalObj.lowBalMsg,
            isPaused:lowBalObj.paused,
            scheduledDayList:_selectedDays,
            loggedUser:JSON.parse(sessionStorage.getItem('loggedInUserInfo')).username
          });
          let headers = {
            'Content-Type': 'application/json'
          };
          if((lowBalObj.recId||0)===0){
            postWithHeaders('/lowBalanceSchoolSettings?access_token=', data, headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
            }).then(data => {
                _addNotification("Lunch balance added.", this);
                setTimeout(() => {
                window.location.replace('/schoolAdmin');
                }, 3000);
            }).catch(
                (error) => {
                    console.log('Low balance data not saved', error)
                }
            );
          }else{
            patch('/lowBalanceSchoolSettings/' + lowBalObj.recId + '?access_token=', data).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                _addNotification("Low Balance School Settings Updated Successfully.", this);
                setTimeout(() => {
                window.location.replace('/schoolAdmin');
                }, 3000);
                // this.getDeletedSchools()
                // this.getSchoolList();
                // this.setState({loading: false});
            })
                .catch(
                    (error) => {
                        _addNotification("Low Balance School Settings Not Updated. Please try again later.", this)
                        this.setState({loading: false});
                        console.log('Low Balance School Settings response', error)
                    }
                )
          }
    }

    render(){
        return(<div>
            <NotificationSystem ref="notificationSystem"/>
            <section className=" full-width clearfix margin-top">
                <div className='sweet-loading'
                     style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">                        
                        <div className="clearfix"></div>
                        <div className="row">
                        <div className="col-md-8 col-sm-12 col-xs-12 col-centered createmenu-panel">
                            <div className="panel panel-primary">
                            <div className="panel-heading text-center"><h3 className="panel-title">Low Balance Email </h3></div>
                            <div className="panel-body">
                                
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                        <fieldset>
                                        <p style={{ display: "inline-block",  float: "left",    margin: "9px 25px"}}>Paused :</p>
                                        <div className="c_checkbox c_checkbox-primary">                    
                                            <input type="checkbox" id="inlineCheckbox1" checked={this.state.lowBalData.paused} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.paused= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="inlineCheckbox1"></label>
                                        </div>
                                        </fieldset>                                        
                                        </div>                                
                                    </div>

                                    <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                    <fieldset>
                                        <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"6px" }}>Run On :</p>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblSun" checked={this.state.lowBalData.runOn.Sun} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Sun= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})

                                            }} />
                                            <label for="lblSun">Sun</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblMon" checked={this.state.lowBalData.runOn.Mon} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Mon= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblMon">Mon</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblTue" checked={this.state.lowBalData.runOn.Tue} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Tue= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblTue">Tue</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblWed" checked={this.state.lowBalData.runOn.Wed} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Wed= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblWed">Wed</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblThu" checked={this.state.lowBalData.runOn.Thu} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Thu= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblThu">Thu</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblFri" checked={this.state.lowBalData.runOn.Fri} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Fri= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblFri">Fri</label>
                                        </div>
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id="lblSat" checked={this.state.lowBalData.runOn.Sat} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.runOn.Sat= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="lblSat">Sat</label>
                                        </div>
                                        </fieldset> 
                                    </div>
                                    </div>

                                    <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                    <fieldset>
                                        <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"25px", marginTop:"6px" }}>At :</p>
                                        <div className="space-bottom col-md-10 col-sm-12 col-xs-12" style={{display:"inline-block"}}>
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                        <select className="form-control" value={this.state.lowBalData.at.hrs} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.at.hrs= event.target.value;
                                                this.setState({lowBalData:lowBalObj})
                                            }}>
                                        {
                                                this.hrs12Options().map(item => {
                                                    return (
                                                        <option key={item.id} value={item.value}>
                                                            {item.text}
                                                        </option>
                                                    )
                                                })
                                            } 
                                        </select>
                                        </div>
                                        <div className="col-md-1" style={{ marginTop:"6px"}}>
                                        <span>:</span>
                                        </div>
                                        <div className="col-md-2">
                                        <select className="form-control" disabled>
                                        <option >00</option>
                                        </select>
                                        </div>
                                        <div className="col-md-3">
                                        <select className="form-control" value={this.state.lowBalData.at.am_pm} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.at.am_pm= event.target.value;
                                                this.setState({lowBalData:lowBalObj})
                                            }} >
                                        <option value="AM" >AM</option><option value="PM">PM</option>
                                        </select>
                                        </div>
                                        </div>
                                    </fieldset>
                                    </div>
                                    </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12" style={{display:'none'}}>
                                    <fieldset>
                                        <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"10px", marginTop:"10px" }}>If customer email is blank, use application email :</p>
                                        <div className="c_checkbox c_checkbox-primary">                    
                                            <input type="checkbox" id="chCustEmaiIsblank" checked={this.state.lowBalData.custEmailIsBlank} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.custEmailIsBlank= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="chCustEmaiIsblank"></label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <fieldset style={{ marginTop: '7px'}}>
                                        <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"10px", marginTop:"6px" }}>Minimum Balance :</p>
                                        <div className="space-bottom col-md-9 col-sm-12 col-xs-12" style={{display:"inline-block"}}>
                                        <div className="col-md-3">
                                        <input type="number" className="form-control" value={this.state.lowBalData.bal.min} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.bal.min= event.target.value;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                        </div>
                                        <div className="col-md-5">
                                        <p style={{ display: "inline-block", marginTop:"6px" }}>Maximum Balance :</p>                                        
                                        </div>
                                        <div className="col-md-3">
                                        <input type="number" className="form-control" value={this.state.lowBalData.bal.max} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.bal.max= event.target.value;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                        </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <fieldset>
                                        <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"10px", marginTop:"10px" }}>Exclude customers with zero balance :</p>
                                        <div className="c_checkbox c_checkbox-primary">                    
                                            <input type="checkbox" id="chExZeroBal" checked={this.state.lowBalData.exZeroBal} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.exZeroBal= event.target.checked;
                                                this.setState({lowBalData:lowBalObj})
                                            }} />
                                            <label for="chExZeroBal"></label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <fieldset>
                                            <p style={{ display: "inline-block",  float: "left",  marginLeft: "23px",  marginRight:"10px" }}>Low-Balance Message :</p>
                                        <div className="space-bottom col-md-8 col-sm-12 col-xs-12" style={{display:"inline-block"}}>
                                            <div className="col-md-12">
                                                <textarea rows="6" cols="50" className="form-control" value={this.state.lowBalData.lowBalMsg} onChange={(event)=>{
                                                let lowBalObj=this.state.lowBalData;
                                                lowBalObj.lowBalMsg= event.target.value;
                                                this.setState({lowBalData:lowBalObj})
                                            }} ></textarea>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                            <span>This low balance emailer last ran on  <b>{moment.utc(this.state.lowBalData.lastRanOn).local().format("MM/DD/YYYY LT") === 'Invalid date' ? '' : moment.utc(this.state.lowBalData.lastRanOn).local().format("MM/DD/YYYY LT")}</b> </span>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-2 pull-right">
                            <button className="btn btn-success" onClick={()=>{
                                this.onSubmit();
                                return false;
                            }}>Save</button>
                            </div>
                            <div className="col-md-2 pull-right">
                            <button className="btn btn-danger" onClick={()=>{
                                this.props.history.push('/schoolAdmin')
                            }}>Cancel</button>
                            </div>
                            </div>
                            </div>
                 
                            </div>
                            </div>
                            </div>
                        </div>
                </div>
            </section>

        </div>);
    }
}
export default LowBalEmailEntry;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/LowBalEmail/LowBalEmailEntry.jsx